import { css } from '@emotion/react'
import { Button, Cell, Flow, Grid, Icon, Text, Tooltip } from 'bold-ui'
import { Box } from 'components/Box'
import { SubmitButton, TextField } from 'components/form'
import { Form, FormRenderProps } from 'components/form/core/Form/Form'
import copy from 'copy-to-clipboard'
import { useConfiguracoes } from 'hooks/configuracoes/useConfiguracoes'
import { metaPath } from 'util/metaPath'
import {
  CadastrarDispositivoPainelChamadasModel,
  PermissaoPainelChamadas,
} from 'view/chamada-painel/model-chamadaPainel'

import { cadastrarDispositivoPainelValidator } from '../validator-cadastrarDispositivoPainel'

interface CadastrarDispositivoPainelChamadasFormProps {
  onSubmit(values: CadastrarDispositivoPainelChamadasModel): Promise<void>
  permissao: PermissaoPainelChamadas
}

const meta = metaPath<CadastrarDispositivoPainelChamadasModel>()

export const CadastrarDispositivoPainelChamadasForm = (
  props: Readonly<CadastrarDispositivoPainelChamadasFormProps>
) => {
  const { onSubmit: handleSubmit, permissao } = props

  const {
    configuracoes: { linkInstalacao },
  } = useConfiguracoes()

  const link = linkInstalacao ? `${linkInstalacao}/painel` : '/painel'

  const handleClickCopy = () => copy(link)

  const renderForm = (formProps: FormRenderProps<CadastrarDispositivoPainelChamadasModel>) => {
    return (
      <Box style={styles.boxPopper}>
        <Flow direction='vertical' justifyItems='stretch'>
          <Grid>
            <Cell>
              <Flow direction='vertical' gap={0}>
                <Text fontWeight='bold'>Utilize o link abaixo para acessar o painel de chamadas</Text>
                <Text>{link}</Text>
              </Flow>
            </Cell>
            <Cell>
              <Tooltip text={permissao.hint ?? undefined}>
                <Button onClick={handleClickCopy} size='small' disabled={!permissao.enabled}>
                  <Flow direction='horizontal' gap={0.5}>
                    <Icon icon='copyOutline' />
                    Copiar link
                  </Flow>
                </Button>
              </Tooltip>
            </Cell>
          </Grid>
          <Grid>
            <Cell size={8}>
              <TextField
                name={meta.nome}
                label='Nome do dispositivo'
                placeholder='Informe um nome para identificar o dispositivo'
                required
                maxLength={50}
              />
            </Cell>
            <Cell size={4}>
              <TextField
                name={meta.codigo}
                label='Código'
                placeholder='Informe o código'
                required
                uppercase
                maxLength={4}
              />
            </Cell>
          </Grid>
          <Flow direction='horizontal' justifyContent='flex-end'>
            <SubmitButton size='small' handleSubmit={formProps.handleSubmit}>
              Adicionar
            </SubmitButton>
          </Flow>
        </Flow>
      </Box>
    )
  }

  return (
    <Form<CadastrarDispositivoPainelChamadasModel>
      render={renderForm}
      onSubmit={handleSubmit}
      validate={cadastrarDispositivoPainelValidator}
    />
  )
}

const styles = {
  boxPopper: css`
    width: 40rem;
  `,
}
